import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
import { userSignIn } from 'actions/Auth';
import CircularProgress from "@material-ui/core/CircularProgress";
import { NotificationContainer } from "react-notifications";
import Button from '@material-ui/core/Button'
import logov from "assets/images/logo_v.png"
import LockOutlined from "@material-ui/icons/LockOutlined";
import LockOpenOutlined from "@material-ui/icons/LockOpenOutlined";
import URLSearchParams from "url-search-params";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import { Box, Typography } from "@material-ui/core";
import * as Yup from "yup";
import { FETCH_ERROR, HIDE_MESSAGE, OTP_INVALID, TF_AUTH, USER_EMAIL } from 'constants/ActionTypes';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const SignIn = (props) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const dispatch = useDispatch();
  const token = useSelector(({ auth }) => auth.token);
  const { loading, message } = useSelector(({ commonData }) => commonData);
  const { tfAuth , otpInvalid} = useSelector(({ auth }) => auth);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [tokenLogin, setTokenLogin] = useState(true);
  const { executeRecaptcha } = useGoogleReCaptcha();
  
  const enterKeyPressed = (e) => {
    let code = e.keyCode || e.which;
    if (code === 13)
      dispatch(userSignIn({ email, password }))
  }
  
  useEffect(() => {
    if (token !== null) {      
      const params = new URLSearchParams(window.location.search);
      const referrer = params.get("referrer") || "/";
      props.history.push(referrer);
    }
  }, [token]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    if(params.has("secret")){
      const secret = params.get("secret");
      setTokenLogin(true);
      dispatch(userSignIn({ email, password, secret }))
    }else{
      setTokenLogin(false);
    }
    if(!tfAuth){
      localStorage.removeItem('otpStartTime');
    }
  }, [props.location.search])

  const formSubmit = async (e)=>{

    e.preventDefault();
    const reCaptchaToken = await executeRecaptcha('login');
    console.log(reCaptchaToken,"reCahptchaToken")
    dispatch({type: USER_EMAIL, payload:email}); 
    dispatch(userSignIn({ email, password,secret: undefined,otp: undefined, reCaptchaToken: reCaptchaToken })); 
  }
  return (
    !tokenLogin && 
    <div
      className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
      <div className="login-content">
        <div className="login-header">
          <Link className="app-logo" to="/" title="ValetEZ">
            <img src={logov} alt="ValetEZ" title="ValetEZ" />
          </Link>
        </div>
        {!tfAuth ?
        <div className="login-form">
          <form onSubmit={formSubmit}>
            <fieldset>
              <div className="form-group">
                <input name="email" id="email" className="form-control form-control-lg"
                  onKeyPress={enterKeyPressed} placeholder="Email" type="email" onChange={(event) => setEmail(event.target.value)} />
              </div>
              <div className="form-group passwordFieldContainer">
                <input name="password" id="password" className="form-control form-control-lg"
                  onKeyPress={enterKeyPressed} placeholder="Password" type={isPasswordVisible ? 'text' : 'password'} onChange={(event) => setPassword(event.target.value)} />
                <span onClick={() => setIsPasswordVisible(!isPasswordVisible)} style={{ cursor: 'pointer', marginRight: '10px' }}>
                  {isPasswordVisible ? <LockOpenOutlined alt="Toggle visibility" /> : <LockOutlined alt="Toggle visibility" />}
                </span>
              </div>
              <div className="form-group d-flex justify-content-between align-items-center">
                  <div>
                    <Link to="/forgetPassword"
                          title="Reset Password"><IntlMessages id="appModule.forgotPassword"/></Link>
                  </div>
                  {message && <div>{message}</div>}
              </div>

              <Button type="submit" className="btn jr-btn-rounded btn-primary btn-rounded"><IntlMessages
                id="appModule.signIn" /></Button>

            </fieldset>
          </form>
        </div>
        : 
        <TFAuth /> }
      </div>
      {
        loading &&
        <div className="loader-view">
          <CircularProgress />
        </div>
      }
      <NotificationContainer />
    </div>
  );
};

const validationSchemaOTP = Yup.object().shape({
  otp: Yup.string()
    .test("otp-length", "OTP is required", function (_, context) {
      const { otp1, otp2, otp3, otp4, otp5, otp6 } = context.parent;
      const otpArray = [otp1, otp2, otp3, otp4, otp5, otp6];
      return otpArray.every((val) => val && val.trim() !== ""); // Ensure all OTP fields are filled
    }),
});


const TFAuth = () => {
  const OTP_DURATION = 180;
  const dispatch = useDispatch();
  const { loading, message } = useSelector(({ commonData }) => commonData);
  const { userEmail, otpInvalid } = useSelector(({ auth }) => auth);
  const [otpField, setOtpField] = useState({otp1:'',otp2:'',otp3:'',otp4:'',otp5:'',otp6:''});
  const inputRefs = useRef([]);

  const getInitialTimeLeft = () => {
    let stored = parseInt(localStorage.getItem('otpStartTime'), 10);
    if (!stored || isNaN(stored)){
      stored = Date.now();
      localStorage.setItem('otpStartTime', stored.toString());
      return OTP_DURATION;
    }

    const elapsed = Math.floor((Date.now() - stored) / 1000);
    const remaining = OTP_DURATION - elapsed;
    return remaining > 0 ? remaining : 0;
  };

  const [timeLeft, setTimeLeft] = useState(getInitialTimeLeft);

  useEffect(() => {
    const startTime = parseInt(localStorage.getItem('otpStartTime'), 10);
    const interval = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      const remaining = OTP_DURATION - elapsed;

      if (remaining <= 0) {
        setTimeLeft(0);
        clearInterval(interval);
        dispatch({ type: OTP_INVALID, payload: true });
        dispatch({ type: FETCH_ERROR, message: "OTP has expired, Please log in again." });
      } else {
        setTimeLeft(remaining);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  
  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleOTPChange = (e, index, setFieldValue) => {
    const { value } = e.target;
    if(!isNaN(Number(value))){
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
      setOtpField(initValue => ({...initValue, [`otp${index + 1}`]:value}))
      setFieldValue(`otp${index + 1}`, value);
    }
  };

  const handleOTPKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (e.target.value === '') {
        if (index > 0) {
          const prevInput = inputRefs.current[index - 1];
          if (prevInput) {
            prevInput.focus();
            prevInput.value = '';
          }
        }
      }
    }
  };

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60).toString().padStart(2, '0');
    const sec = (seconds % 60).toString().padStart(2, '0');
    return `${min}:${sec}`;
  };

  const backToSignin = () => {
    dispatch({type:TF_AUTH, payload: false});
    dispatch({type:OTP_INVALID, payload: false});
    dispatch({type:HIDE_MESSAGE})
    localStorage.removeItem('otpStartTime');
  }
  return(
    <div className="login-form">
      <Formik
        initialValues={{ otp1:"", otp2:"", otp3:"", otp4:"", otp5:"", otp6:"" }}
        validationSchema={validationSchemaOTP}
        onSubmit={(values) => {
          const otp = Object.values(values).join('');
          dispatch(userSignIn({ email:userEmail, password: undefined, secret: undefined, otp }));
        }}
      >
        {({ handleSubmit, setFieldValue, errors, touched, submitCount }) => (
          <Form onSubmit={handleSubmit}  autoComplete="new-password">
            <Box mb={1}>
              <Typography variant="body2">Enter the 6-digit OTP sent to your email.</Typography>
              <Box display="flex" justifyContent="space-between" mt={1}>
                {[...Array(6)].map((_, index) => (
                  <Field
                    autoComplete="new-password"
                    key={index}
                    component={TextField}
                    name={`otp${index + 1}`}
                    variant="outlined"
                    inputRef={(el) => (inputRefs.current[index] = el)}
                    disabled={loading}
                    inputProps={{
                      maxLength: 1,
                      style: { textAlign: "center" },
                      onChange: (e) => handleOTPChange(e, index, setFieldValue ),
                      onKeyDown: (e) => handleOTPKeyDown(e, index),
                      inputMode: "numeric",
                      autoComplete: "one-time-code",
                    }}
                    value={otpField[`otp${index+1}`]}
                    style={{ width: "3rem", marginRight: "0.5rem" }}
                  />
                ))}
              </Box>
            </Box>
            {submitCount> 0 && errors.otp  && <Typography variant="body2" color="error" style={{marginBottom:2}}>{errors.otp}</Typography>}
            <div className="form-group"
              style={{
                width: '100%',
                textAlign: 'right',
                marginTop: 2,
                color: timeLeft === 0 ? '#6c757d' : 'inherit',
                opacity: timeLeft === 0 ? 0.6 : 1
              }}
            >
              Time left: <strong>{formatTime(timeLeft)}</strong>
            </div>
            <div className="form-group d-flex flex-column">
              {message && (<Typography variant="body2" color="error" style={{ marginBottom: 10 }}>{message}</Typography>)} 
              {otpInvalid && ( <div style={{ width: '100%', textAlign: 'left', marginTop: 2 }}>
                <Link to="" onClick={backToSignin} title="Login again!"> <IntlMessages id="appModule.loginAgain" /> </Link>
              </div>)}
            </div>
            <Button type="submit" className="btn jr-btn-rounded btn-primary btn-rounded" disabled={timeLeft === 0 || otpInvalid}>
              <IntlMessages id="appModule.verifyOtp"/>
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  )
  
}


export default SignIn;
